module.exports = __webpack_public_path__ + "nc_static/media/remote access.f8de47ec.svg";